<template>
  <Layout>
    <v-container
      class="fill-height"
      fluid
      pa-0
    >
      <v-row class="fill-height">
        <v-col>
          <v-row class="fill-height">
            <QuestionList
              :questions="questions"
              @newQuestion="questionSelected"
              @refreshQuestion="getQuestions"
            />
          </v-row>
        </v-col>
        <v-col class="fill-height">
          <v-row
            class="fill-height"
            align="start"
            justify="start"
          >
            <QuestionDetail
              :question="question"
              @refreshQuestion="getQuestions"
            />
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </Layout>
</template>

<script>
import Layout from '@/components/Layout.vue';
import QuestionList from '@/components/QuestionList.vue';
import QuestionDetail from '@/components/QuestionDetail.vue';

export default {
  name: 'Question',
  components: {
    Layout,
    QuestionList,
    QuestionDetail,
  },
  data() {
    return {
      question: {},
    };
  },

  computed: {
    questions() {
      return this.$store.state.question.questions;
    },
  },
  watch: {},
  beforeMount() {
    this.getQuestions();
  },
  methods: {
    async getQuestions() {
      await this.$store.dispatch('question/get');
    },
    questionSelected(item) {
      this.question = item;
    },
  },
};
</script>
